module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./BirthdayCardView.js"));
	}, "BirthdayCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BirthdayCardView!./src/pages/Shop/Home/MemberBirthday/BirthdayCard/BirthdayCardView.js
// module id = 940
// module chunks = 431